export default __webpack_public_path__ + "static/card_badges_status-8e70cfeaa6bbe843efceabc6dd657baa.png";